import * as React from "react"
import { Box } from "@mui/material"
import { ActionButton } from "@components"

import {userDrawerFilters} from "../../@signals";


export default function CreateUserButton({ customerID, customerName }) {

    return <Box componet="span">
        <ActionButton
            label="Create New User"
            icon="hexagon-plus"
            onClick={() => {
                userDrawerFilters.value = {
                    customerID: customerID,
                    customerName: customerName,
                    createMode: true,
                    userName: '',
                    password: '',
                    email: '',
                    accessValues: [],
                    skuGroupsValues: [],
                    sitesScopeValues: []
                }
            }}
        />
    </Box>
}